<template>
  <nav class="join-us-header-nav-top" :class="activeIndex===0||activeIndex===5?'trans':'white'">
    <div class="join-us-header-nav-top-content">
      <div class="img-logo-wrap">
        <a :to="{name:'home'}"  @click="navigatorRoute('home', 0)">
          <img src="../../assets/icon-logo.png" alt="" v-if="activeIndex===0||activeIndex===5">
          <img src="../../assets/icon-logo-actived.png" alt="" v-else>
        </a>
      </div>
      <div class="right">
        <a v-for="(item, index) in navData" :key="index" @click="navigatorRoute(item.name)"
           :class="activeIndex===0||activeIndex===5 ? 'home':null"
        >{{item.txt}}<span :class="activeIndex===index?'active':null"></span></a>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'nav-header',
    props: {
      activeIndex: {
        type: Number
      }
    },
    data () {
      return {
        navData: [
          { name: 'home', txt: '首页' },
          { name: 'home-service', txt: '圣诉服务' },
          { name: 'home-lawyer', txt: '圣诉律师' },
          { name: 'home-article', txt: '圣诉文章' },
          { name: 'home-advantage', txt: '圣诉优势' },
          { name: 'join-us', txt: '加入圣诉' },
          { name: 'login', txt: '登录' },
          { name: 'register', txt: '注册' }
        ]
      }
    },
    methods: {
      // 路由跳转
      navigatorRoute (path) {
        let router = this.$router.resolve({
          name: path
        })
        if (path !== this.$route.name) {
          if (path === 'register') {
            localStorage.setItem('unionId', '')
          }
          window.open(router.href)
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .join-us-header-nav-top {
    position absolute
    top 0
    left 0
    width: 100%
    height: .72rem
    z-index 10
    &-content {
      width: 9.6rem
      height .72rem
      margin 0 auto
      display: flex
      align-items center
      justify-content space-between
      img {
        width: 1.74rem
        height: .60rem
      }
      .right {
        a {
          display inline-block
          text-align center
          font-size: .16rem
          color #1d1b1b
          margin-right .32rem
          position relative
          padding-bottom .06rem
          span {
            position absolute
            bottom 0
            left 50%
            transform translateX(-50%)
            display inline-block
            width: .6rem
            height 100%
          }
          span.active {
            border-bottom .02rem solid #ed6c00
          }
        }
        .home {
          color: #fff
        }
      }
    }
  }
  .trans {
    background transparent
  }
  .white {
    background #fff
  }
</style>



// WEBPACK FOOTER //
// src/common-components/nav-header/nav-header.vue